<template>
  <form autocomplete="false" v-on:submit.prevent>
    <vue-form-generator :schema="schema" :model="datas" :options="formOptions"></vue-form-generator>
  </form>
</template>

<script>
import { getModeles, addModele, updateModele, deleteModele } from '@/api/crm-api.js'

export default {
  props: {
    id: String
  },
  data () {
    return {
      datas: {},
      schema: {
        groups: [
          {
            legend: 'Modèle',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Nom',
                model: 'nom',
                placeholder: 'Nom'
              }
            ]
          },
          {
            legend: '',
            fields: [
              {
                type: 'submit',
                buttonText: 'Ajouter',
                onSubmit: this.add,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: true,
                visible (modele) {
                    return modele != null && modele.id == null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Sauver',
                validateBeforeSubmit: true,
                onSubmit: this.update,
                styleClasses:'col-auto p-0 float-right',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Supprimer',
                validateBeforeSubmit: false,
                onSubmit: this.delete,
                styleClasses:'col-auto float-left p-0',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  methods: {
    add () {
      addModele(this.datas).then((response) => {
        this.$router.push({name:'modelesManager', params:{ id: response.data.id }}).catch(() => {})
        this.$store.commit('addMessage',{text:'Le modele ' + this.datas.nom + ' à été crée', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    update () {
      updateModele(this.id,this.datas).then(() => {
        this.$store.commit('addMessage',{text:'Le modele ' + this.datas.nom + ' à été mis à jour', status:'success'})
        this.$emit('onUpdate')
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    delete () {
      if (confirm("Etes vous sur de vouloir supprimer le modele " + this.datas.nom)){
        deleteModele(this.id).then(() => {
          this.$emit('onDelete')
          this.$store.commit('addMessage',{text:'Le modele à été supprimé', status:'success'})
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
        })
      }
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        if(this.id != null) {
          getModeles(this.id)
          .then((response) => {
            this.datas = response.data
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
          })
        } else {
          this.datas = {}
        }
      }
    }
  },
}
</script>

<style>

</style>
